import { render, staticRenderFns } from "./BatchStockList.vue?vue&type=template&id=4ec69458"
import script from "./BatchStockList.vue?vue&type=script&lang=js"
export * from "./BatchStockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ec69458')) {
      api.createRecord('4ec69458', component.options)
    } else {
      api.reload('4ec69458', component.options)
    }
    module.hot.accept("./BatchStockList.vue?vue&type=template&id=4ec69458", function () {
      api.rerender('4ec69458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/batch-stock/BatchStockList.vue"
export default component.exports